module.exports = __webpack_public_path__ + "assets/alerts_blue.8f426ad5.svg";